import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/faqs';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section aria-labelledby="faq-title" className="bg-brand-cream px-4 py-20 md:py-28" data-id="element-64" data-mp="1ntzwd4buliz7">
      <Reveal className="mx-auto max-w-3xl" data-id="element-65" data-mp="2bju8fjocf3ie">
        <div className="mb-12 text-center" data-id="element-66" data-mp="2bkvt8fv5v4db">
          <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal" data-id="element-67" data-mp="2flpipdo94r8b">BUONO A SAPERSI</p>
          <h2 id="faq-title" className="text-3xl font-extrabold tracking-tight text-brand-primary md:text-4xl" data-id="element-68" data-mp="21vcd3hyu1om5">
            Domande Frequenti
          </h2>
        </div>
        <div className="space-y-3" data-id="element-69" data-mp="2uj85wbla6wdn">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="overflow-hidden rounded-[18px] bg-brand-alt" data-id="element-70" data-mp="1vphue07s9ttd" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left font-bold text-brand-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-accent md:px-6" data-id="element-71" data-mp="1ro5zbf654gds">
                  <span className="text-sm md:text-base" data-id="element-72" data-mp="2aee1nv20n2sx">{question}</span>
                  {open ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-73" data-mp="2odnf4myu7it7" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-74" data-mp="2jdiv4myq05y8" />}
                </button>
                <AnimatePresence initial={false} data-id="element-75" data-mp="p24482tz40gw">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-76" data-mp="2p43q68ffc5ws">
                      <p className="px-5 pb-6 text-sm leading-relaxed text-brand-gray md:px-6" data-id="element-77" data-mp="382g03we5tjtf">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}